/* eslint-disable @typescript-eslint/naming-convention */
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { DispatchFilterOptions, DispatchFilterTabsConfig } from '../dispatch-filter.interface';
import { ModuleAccess } from '../../dispatch-board/dispatch-board.interface';
import { v4 as uuidv4 } from 'uuid';
import { ZuperDrawerComponent, ZuperDrawerService } from '@zuper/components/zuper-drawer';
import { AdditionalFilter } from 'app/components/quick-filter/advance-filter/advance-filter.interface';

@Component({
  selector: 'app-dispatch-filter-drawer',
  templateUrl: './dispatch-filter-drawer.component.html',
  styleUrls: ['./dispatch-filter-drawer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DispatchFilterDrawerComponent implements OnInit, OnChanges {
  @Input() openFilter: boolean = false;
  @Input() selectedModule: 'GRID' | 'EMPLOYEE' | 'SCHEDULER' | 'MAP' = 'GRID';
  @Input() currentTab: 'JOBS' | 'ROUTES' = 'JOBS';
  @Input() isNewFilter: boolean = false;
  @Input() isMapViewEnabled: boolean = false;
  @Output() filterDrawerEmitter: EventEmitter<any> = new EventEmitter();
  @Input() dispatchFilterValues: any = null;
  @Input() filterOptions: DispatchFilterOptions;
  @Input() filterOptionalValues: any = {};
  @Input() saveFilterByDefault: boolean;
  @Input() moduleAccess: ModuleAccess;
  @Input() hideSaveFilter: boolean;
  @Input() filterTabs: DispatchFilterTabsConfig;
  @Input() selectedTeamUid?: string = null;
  @Input() additionalFilters?: AdditionalFilter = {};
  @Output() filterEmitter: EventEmitter<any> = new EventEmitter();

  drawerName: string = 'dispatch_filter';
  filterEmitValue: any = null;

  constructor(
    private zuperDrawerService: ZuperDrawerService) {
  }

  ngOnInit(): void {
    this.drawerName = this.drawerName + '_' + uuidv4();
  }

  filterEventHandler(event: any): void {
    if (event.isClosed) {
      this.openFilter = false;
      this.filterEmitValue = event;
      this.drawerClose();
    }
  }

  //#region Drawer Related Methods
  drawerOpenedChanged(isOpened: boolean): void {
    if (!isOpened) {
      this.filterDrawerEmitter.emit(this.filterEmitValue ?? { isClosed: true });
    }
  }

  drawerClose(): void {
    const drawer: ZuperDrawerComponent = this.zuperDrawerService.getComponent(this.drawerName);
    drawer.close();
  }

  toggleDrawer(isOpen: boolean): void {
    const drawer: ZuperDrawerComponent = this.zuperDrawerService.getComponent(this.drawerName);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    isOpen ? drawer?.open() : this.drawerClose();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.openFilter?.previousValue !== undefined) {
      this.toggleDrawer(changes?.openFilter.currentValue);
    }
  }
  //#endregion
}
